import React from 'react';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { INFO_BUTTON_COLOR } from 'src/utils/colors';
import TooltipNew from 'src/App/Dashboards/Market/Components/Tooltips/TooltipNew';

const InfoButton = ({
  title,
  tooltipContent,
  iconColor,
  extraStyles,
}: {
  title?: string | JSX.Element;
  tooltipContent: JSX.Element | string;
  iconColor?: string;
  extraStyles?: React.CSSProperties;
}) => {
  return (
    <TooltipNew title={title} content={tooltipContent}>
      <InfoOutlined
        sx={{
          fontSize: 16,
          color: iconColor ? iconColor : INFO_BUTTON_COLOR,
          cursor: 'pointer',
          ...extraStyles,
        }}
      />
    </TooltipNew>
  );
};

export default InfoButton;
